module.exports = __webpack_public_path__ + "img/wurlitzer_large_diamond.a2f353e7.png";